/* tslint:disable:max-line-length */
/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

export const JewelleryIcon: React.SFC = () => {
    return (
        <svg width="46" height="46" viewBox="0 0 46 46" xmlns="http://www.w3.org/2000/svg">
            <title>Icon / jewellery</title>
            <g fillRule="nonzero" fill="#F07662">
                <path d="M31.707 2L44 14.293v17.414L31.707 44H14.293L2 31.707V14.293L14.293 2h17.414zm-.414 1H14.707L3 14.707v16.586L14.707 43h16.586L43 31.293V14.707L31.293 3z" />
                <path d="M29.207 8L38 16.793v12.414L29.207 38H16.793L8 29.207V16.793L16.793 8h12.414zm-.414 1H17.207L9 17.207v11.586L17.207 37h11.586L37 28.793V17.207L28.793 9z" />
                <path d="M28.947 8.724l3-6-.894-.448-3 6M14.053 2.724l3 6 .894-.448-3-6M17.053 37.276l-3 6 .894.448 3-6M31.947 43.276l-3-6-.894.448 3 6M8.724 17.053l-6-3-.448.894 6 3M2.724 31.947l6-3-.448-.894-6 3M37.276 28.947l6 3 .448-.894-6-3M43.276 14.053l-6 3 .448.894 6-3M20.646 14.354l10 10c.196.195.512.195.708 0 .195-.196.195-.512 0-.708l-10-10c-.196-.195-.512-.195-.708 0-.195.196-.195.512 0 .708zM24.646 13.354l5.5 5.5c.196.195.512.195.708 0 .195-.196.195-.512 0-.708l-5.5-5.5c-.196-.195-.512-.195-.708 0-.195.196-.195.512 0 .708z" />
            </g>
        </svg>
    )
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/images/icons/AssetsIcons/Jewellery.tsx